import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import logo from '../../assets/images/logo.png';

const columns = [
  {
    title: 'Product',
    links: [
      { label: 'Dares', href: '/blog/dare-night-guide' },
      { label: 'Couple Quiz', href: '/quiz' },
      { label: 'Stories', href: '/blog/roleplay-beginners' },
      { label: 'Never Have I Ever', href: '/blog/science-of-play' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Blog', href: '/blog' },
      { label: 'Press', href: '/about#press' },
      { label: 'Contact', href: '/contact' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Contact Us', href: '/contact' },
      { label: 'FAQ', href: '/blog/two-yes-rule' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
      { label: 'Cookie Policy', href: '/cookies' },
    ],
  },
];

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.grid}>
          <div className={styles.brand}>
            <div className={styles.logoRow}>
              <img src={logo} alt="" width={32} height={32} />
              <span className={styles.wordmark}>LuvLust</span>
            </div>
            <p className={styles.tagline}>
              The couples app for partners who want to flirt harder, play deeper, and discover new sides of each other.
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title} className={styles.column}>
              <h4 className={styles.colTitle}>{col.title}</h4>
              <ul>
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.href} className={styles.footerLink}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className={styles.legal}>
          <span>&copy; {new Date().getFullYear()} LuvLust. All rights reserved.</span>
          <span>Made with ♥ for couples everywhere</span>
        </div>
      </div>
    </footer>
  );
}
